var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container mt-5 mb-5" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-md-12 center mt-5" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("h5", { staticClass: "black" }, [
              _vm._v(
                "\n          Tutti i campi sono obbligatori e puoi modificare le celle di colore\n          bianco.\n        "
              )
            ]),
            _vm._v(" "),
            _vm.proccess == "START"
              ? _c("p", { staticClass: "black" }, [
                  _vm._v(
                    "\n          In caso di variazione di email, partita iva o codice fiscale\n          contatta il assistenza\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center" }, [
          _vm.proccess == "START"
            ? _c(
                "form",
                {
                  staticClass: "pb-5 black vaillantCont widthFull",
                  attrs: { id: "registration-form" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "row mb-4 justify-content-center" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-5 col-md-3 mb-3 pl-md-5 pr-md-5" },
                        [
                          _vm.logo
                            ? _c("img", {
                                staticClass: "img-fluid",
                                attrs: { src: _vm.logo }
                              })
                            : _c("img", {
                                staticClass: "img-fluid",
                                attrs: {
                                  src: require("../../assets/images/DEFAULT_LOGO.png")
                                }
                              })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4 mb-3" }, [
                        _vm.logo
                          ? _c("div", { staticClass: "center" }, [
                              _vm._v(
                                "\n              Cambia Logo (formato: jpg, png)\n            "
                              )
                            ])
                          : _c("div", { staticClass: "center" }, [
                              _vm._v(
                                "\n              Carica Logo (formato: jpg, png)\n            "
                              )
                            ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "front-image" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: false,
                                  size: 10240,
                                  ext: ["jpeg", "jpg", "png"],
                                  mimes: [
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png"
                                  ]
                                },
                                expression:
                                  "{\n                  required: false,\n                  size: 10240,\n                  ext: ['jpeg', 'jpg', 'png'],\n                  mimes: ['image/jpeg', 'image/jpg', 'image/png'],\n                }"
                              }
                            ],
                            ref: "fileInput",
                            staticClass: "fileInput",
                            class: {
                              "is-invalid": _vm.errors.has("invoiceFront"),
                              valid: !!_vm.invoiceFront,
                              helper: !!_vm.invoiceFrontBucket
                            },
                            attrs: {
                              type: "file",
                              name: "invoiceFront",
                              id: "invoiceFront",
                              "data-vv-as": "Logo"
                            },
                            on: { change: _vm.uploadFile }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel labelFileInput",
                              attrs: { for: "invoiceFront" }
                            },
                            [
                              !_vm.invoiceFrontName
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "smallText center white",
                                      style: {
                                        backgroundImage:
                                          "url(" + _vm.invoiceFrontBucket + ")"
                                      }
                                    },
                                    [
                                      !_vm.invoiceFrontName
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "smallText center white mt-3 mb-0 pb-0"
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Scegli il Contratto quadro*\n                  "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _c("span", {
                                    staticClass: "smallText center white",
                                    style: {
                                      backgroundImage:
                                        "url(" + _vm.invoiceFrontBucket + ")"
                                    }
                                  })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("invoiceFront")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("invoiceFront")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.uploadFrontPercentage
                            ? _c(
                                "div",
                                {
                                  staticClass: "progress",
                                  attrs: { id: "progFront" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "progress-bar",
                                      style: {
                                        width: _vm.uploadFrontPercentage + "%"
                                      },
                                      attrs: {
                                        id: "progress-bar-front",
                                        role: "progressbar",
                                        "aria-valuenow": "50",
                                        "aria-valuemin": "0",
                                        "aria-valuemax": "100"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.uploadFrontPercentage) +
                                          " %\n                "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.invoiceFrontName
                            ? _c("p", {
                                staticClass:
                                  "smallText center white mt-3 mb-0 pb-0 fileNameText"
                              })
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        !_vm.logo
                          ? _c(
                              "small",
                              { staticClass: "pt-4 pl-3 pr-3 center" },
                              [
                                _vm._v(
                                  "\n              Il campo non è obbligatorio. Se carichi il logo potremo\n              personalizzare i tuoi preventivi con il logo della tua azienda.\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.azienda,
                              expression: "azienda"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true, max: 128, min: 3 },
                              expression: "{ required: true, max: 128, min: 3 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("azienda"),
                            valid: !!_vm.azienda
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "azienda",
                            id: "azienda",
                            name: "azienda",
                            "data-vv-as": "Ragione sociale"
                          },
                          domProps: { value: _vm.azienda },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.azienda = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "azienda" }
                          },
                          [_vm._v("Ragione sociale *\n              ")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("azienda")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("azienda")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.partita_iva,
                              expression: "partita_iva"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: !_vm.codice_fiscale,
                                partitaIva: true,
                                max: 11,
                                min: 11
                              },
                              expression:
                                "{\n                  required: !codice_fiscale,\n                  partitaIva: true,\n                  max: 11,\n                  min: 11,\n                }"
                            }
                          ],
                          staticClass: "form-control disabled",
                          class: {
                            "is-invalid": _vm.errors.has("partita_iva"),
                            valid: !!_vm.partita_iva
                          },
                          attrs: {
                            type: "text",
                            disabled: "",
                            autocomplete: "partina-iva",
                            id: "partita_iva",
                            name: "partita_iva",
                            "data-vv-as": "Partita IVA"
                          },
                          domProps: { value: _vm.partita_iva },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.partita_iva = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "partita_iva" }
                          },
                          [_vm._v("Partita IVA *")]
                        ),
                        _vm._v(" "),
                        _vm.existPIVA
                          ? _c(
                              "div",
                              {
                                staticClass: "invalid-feedback",
                                staticStyle: { display: "block" }
                              },
                              [
                                _c("span", [
                                  _vm._v("Partita IVA inserita già presente.")
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("partita_iva")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("partita_iva")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.codice_fiscale,
                              expression: "codice_fiscale"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: !_vm.partita_iva,
                                codiceFiscale: true,
                                max: 16,
                                min: 16
                              },
                              expression:
                                "{\n                  required: !partita_iva,\n                  codiceFiscale: true,\n                  max: 16,\n                  min: 16,\n                }"
                            }
                          ],
                          staticClass: "form-control disabled",
                          class: {
                            "is-invalid": _vm.errors.has("codice_fiscale"),
                            valid: !!_vm.codice_fiscale
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "codice-fiscale",
                            id: "codice_fiscale",
                            disabled: "",
                            name: "codice_fiscale",
                            "data-vv-as": "Codice Fiscale"
                          },
                          domProps: { value: _vm.codice_fiscale },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.codice_fiscale = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "codice_fiscale" }
                          },
                          [_vm._v("o Codice Fiscale *")]
                        ),
                        _vm._v(" "),
                        _vm.existCF
                          ? _c(
                              "div",
                              {
                                staticClass: "invalid-feedback",
                                staticStyle: { display: "block" }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    "Codice Fiscale inserito già presente."
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("codice_fiscale")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("codice_fiscale")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("div", { staticClass: "col-md-2" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.id_eps,
                              expression: "id_eps"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {},
                              expression: "{}"
                            }
                          ],
                          staticClass: "form-control disabled",
                          class: {
                            "is-invalid": _vm.errors.has("id_eps"),
                            valid: !!_vm.id_eps
                          },
                          attrs: {
                            type: "text",
                            disabled: "",
                            id: "id_eps",
                            name: "id_eps",
                            "data-vv-as": "Tipo Azienda"
                          },
                          domProps: { value: _vm.id_eps },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.id_eps = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "id_eps" }
                          },
                          [_vm._v("Tipo Azienda ")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("id_eps")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("id_eps")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.id_eps == "Ditta Individuale" ||
                    _vm.id_eps == "Professionista iscritto ad albi"
                      ? _c("div", { staticClass: "col-md-4 mb-3" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.reg_forfettario,
                                    expression: "reg_forfettario"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true },
                                    expression: "{ required: true }"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has(
                                    "reg_forfettario"
                                  ),
                                  valid: !!_vm.reg_forfettario,
                                  disabled:
                                    _vm.getProfile.reg_forfettario != "0"
                                },
                                attrs: {
                                  autocomplete: "randomy",
                                  id: "reg_forfettario",
                                  disabled:
                                    _vm.getProfile.reg_forfettario != "0",
                                  name: "reg_forfettario",
                                  "data-vv-as": "Regime Forfettario"
                                },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.reg_forfettario = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  { key: 911, attrs: { value: "si" } },
                                  [_vm._v("si")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  { key: 912, attrs: { value: "no" } },
                                  [_vm._v("no")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "region" }
                              },
                              [_vm._v("Regime Forfettario *")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("reg_forfettario")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.errors.first("reg_forfettario")
                                      ) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.name,
                              expression: "name"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true, max: 55, min: 2 },
                              expression: "{ required: true, max: 55, min: 2 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("name"),
                            valid: !!_vm.name
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "name",
                            id: "name",
                            name: "name",
                            "data-vv-as": "Nome"
                          },
                          domProps: { value: _vm.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.name = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "name" }
                          },
                          [_vm._v("Nome *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("name")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("name")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.lastname,
                              expression: "lastname"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true, max: 55, min: 2 },
                              expression: "{ required: true, max: 55, min: 2 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("lastname"),
                            valid: !!_vm.lastname
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "lastname",
                            id: "lastname",
                            name: "lastname",
                            "data-vv-as": "Cognome"
                          },
                          domProps: { value: _vm.lastname },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.lastname = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "lastname" }
                          },
                          [_vm._v("Cognome *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("lastname")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("lastname")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-4" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.email,
                              expression: "email"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: true,
                                email: true,
                                temporaryEmail: true,
                                plusIssueEmail: true,
                                max: 56
                              },
                              expression:
                                "{\n                  required: true,\n                  email: true,\n                  temporaryEmail: true,\n                  plusIssueEmail: true,\n                  max: 56,\n                }"
                            }
                          ],
                          ref: "email",
                          staticClass: "form-control disabled",
                          class: {
                            "is-invalid":
                              _vm.errors.has("email") || _vm.existEmail,
                            valid: !!_vm.email
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "email",
                            disabled: "",
                            id: "email",
                            name: "email",
                            "data-vv-as": "Email"
                          },
                          domProps: { value: _vm.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.email = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "email" }
                          },
                          [_vm._v("Email * ")]
                        ),
                        _vm._v(" "),
                        _vm.existEmail
                          ? _c(
                              "div",
                              {
                                staticClass: "invalid-feedback",
                                staticStyle: { display: "block" }
                              },
                              [
                                _c("span", [
                                  _vm._v("Email digitato già presente")
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("email")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("email")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.phone,
                              expression: "phone"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: true,
                                max: 12,
                                min: 8,
                                notZeros: true,
                                regex: /^[0,3]+/
                              },
                              expression:
                                "{\n                  required: true,\n                  max: 12,\n                  min: 8,\n                  notZeros: true,\n                  regex: /^[0,3]+/,\n                }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("phone"),
                            valid: !!_vm.phone
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "telefono",
                            id: "phone",
                            name: "phone",
                            "data-vv-as": "Telefono"
                          },
                          domProps: { value: _vm.phone },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.phone = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "phone" }
                          },
                          [_vm._v("Telefono * ")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("phone")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("phone")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cellulare,
                              expression: "cellulare"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: true,
                                max: 12,
                                min: 8,
                                notZeros: true,
                                regex: /^[0,3]+/
                              },
                              expression:
                                "{\n                  required: true,\n                  max: 12,\n                  min: 8,\n                  notZeros: true,\n                  regex: /^[0,3]+/,\n                }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("cellulare"),
                            valid: !!_vm.cellulare
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "cellulare",
                            id: "cellulare",
                            name: "cellulare",
                            "data-vv-as": "Cellulare"
                          },
                          domProps: { value: _vm.cellulare },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.cellulare = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "cellulare" }
                          },
                          [_vm._v("Cellulare *\n              ")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("cellulare")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("cellulare")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.address,
                              expression: "address"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true, max: 128, min: 5 },
                              expression: "{ required: true, max: 128, min: 5 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("address"),
                            valid: !!_vm.address
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "indirizzo",
                            id: "address",
                            name: "address",
                            "data-vv-as": "Indirizzo"
                          },
                          domProps: { value: _vm.address },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.address = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "address" }
                          },
                          [_vm._v("Indirizzo *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("address")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("address")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-2 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.civic,
                              expression: "civic"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true, max: 15 },
                              expression: "{ required: true, max: 15 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("civic"),
                            valid: !!_vm.civic
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "civico",
                            id: "civic",
                            name: "civic",
                            "data-vv-as": "Civico"
                          },
                          domProps: { value: _vm.civic },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.civic = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "civic" }
                          },
                          [_vm._v("Civico *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("civic")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("civic")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.region,
                                expression: "region"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{ required: true }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("region"),
                              valid: !!_vm.region
                            },
                            attrs: {
                              autocomplete: "region-new",
                              id: "region",
                              name: "region",
                              "data-vv-as": "Regione"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.region = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.regions, function(region) {
                            return _c(
                              "option",
                              {
                                key: region.id_regione,
                                domProps: {
                                  value: {
                                    id: region.id_regione,
                                    text: region.regione
                                  },
                                  selected:
                                    region.id_regione == _vm.shipData.region
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(region.regione) +
                                    "\n                "
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "region" }
                          },
                          [_vm._v("Regione *")]
                        ),
                        _vm._v(" "),
                        _vm.regionsState
                          ? _c(
                              "div",
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "loadSpinner",
                                  attrs: {
                                    id: "loadregion",
                                    icon: "spinner",
                                    size: "1x",
                                    pulse: ""
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("region")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("region")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.province,
                                expression: "province"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{ required: true }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("province"),
                              valid: !!_vm.province
                            },
                            attrs: {
                              autocomplete: "randomy",
                              id: "province",
                              name: "province",
                              "data-vv-as": "Provincia"
                            },
                            on: {
                              click: _vm.checkRegion,
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.province = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.provincies, function(province) {
                            return _c(
                              "option",
                              {
                                key: province.sigla,
                                domProps: {
                                  value: province.sigla,
                                  selected:
                                    province.sigla == _vm.shipData.province
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(province.sigla) +
                                    " - " +
                                    _vm._s(province.provincia) +
                                    "\n                "
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "province" }
                          },
                          [
                            _vm._v("Provincia *"),
                            _vm.provinceError
                              ? _c("span", { staticClass: "formError" }, [
                                  _vm._v("Prima scegli Regione")
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.provinciesState
                          ? _c(
                              "div",
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "loadSpinner",
                                  attrs: {
                                    id: "loadProvince",
                                    icon: "spinner",
                                    size: "1x",
                                    pulse: ""
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("province")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("province")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.city,
                                expression: "city"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{ required: true }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("city"),
                              valid: !!_vm.city
                            },
                            attrs: {
                              autocomplete: "randomu",
                              id: "city",
                              name: "city",
                              "data-vv-as": "Località",
                              disabled: _vm.citiesState
                            },
                            on: {
                              click: _vm.checkProvince,
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.city = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.cities, function(city) {
                            return _c(
                              "option",
                              {
                                key: city.comune,
                                domProps: {
                                  value: {
                                    cityistat: city.istat,
                                    city: city.comune
                                  },
                                  selected: city.comune == _vm.shipData.city
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(city.comune) +
                                    "\n                "
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "city" }
                          },
                          [
                            _vm._v("Località *"),
                            _vm.cityError
                              ? _c("span", { staticClass: "formError" }, [
                                  _vm._v("Prima scegli Provincia")
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.citiesState
                          ? _c(
                              "div",
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "loadSpinner",
                                  attrs: {
                                    id: "loadCity",
                                    icon: "spinner",
                                    size: "1x",
                                    pulse: ""
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("city")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("city")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.zip,
                                expression: "zip"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{ required: true }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("zip"),
                              valid: !!_vm.zip
                            },
                            attrs: {
                              autocomplete: "zip",
                              id: "zip",
                              name: "zip",
                              "data-vv-as": "Cap",
                              disabled: _vm.zipsState
                            },
                            on: {
                              click: _vm.checkZip,
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.zip = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.zips, function(zip) {
                            return _c(
                              "option",
                              {
                                key: zip.cap,
                                domProps: {
                                  value: zip.cap,
                                  selected: zip.cap == _vm.shipData.zip
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(zip.cap) +
                                    "\n                "
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "zip" }
                          },
                          [
                            _vm._v("Cap *"),
                            _vm.zipError
                              ? _c("span", { staticClass: "formError" }, [
                                  _vm._v("Prima scegli Località")
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.zipsState
                          ? _c(
                              "div",
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "loadSpinner",
                                  attrs: {
                                    id: "loadZips",
                                    icon: "spinner",
                                    size: "1x",
                                    pulse: ""
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("zip")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("zip")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "row justify-content-center divider"
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "row justify-content-center divider"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password,
                              expression: "password"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { passwordCheck: true, min: 8, max: 56 },
                              expression:
                                "{ passwordCheck: true, min: 8, max: 56 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("password"),
                            valid: !!_vm.password
                          },
                          attrs: {
                            type: "password",
                            autocomplete: "new-password",
                            id: "password",
                            name: "password",
                            "data-vv-as": "Password"
                          },
                          domProps: { value: _vm.password },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.password = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "password" }
                          },
                          [_vm._v("Scegli nuova password *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("password")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("password")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.confirm_password,
                              expression: "confirm_password"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: !!_vm.password,
                                passwordCheck: true,
                                min: 8,
                                max: 56,
                                confirmed: _vm.password
                              },
                              expression:
                                "{\n                  required: !!password,\n                  passwordCheck: true,\n                  min: 8,\n                  max: 56,\n                  confirmed: password,\n                }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("confirm_password"),
                            valid: !!_vm.confirm_password
                          },
                          attrs: {
                            type: "password",
                            autocomplete: "confirm-new-password",
                            id: "confirm_password",
                            name: "confirm_password",
                            "data-vv-as": "Conferma Password"
                          },
                          domProps: { value: _vm.confirm_password },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.confirm_password = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "confirm_password" }
                          },
                          [_vm._v("Conferma nuova password *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("confirm_password")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("confirm_password")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "row justify-content-center divider"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12 center mb-0 pt-4 mb-1" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-lg btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.editUser("normal")
                              }
                            }
                          },
                          [_vm._v("\n              Salva\n            ")]
                        )
                      ]
                    )
                  ])
                ]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "Bold" }, [_c("b", [_vm._v("ANAGRAFICA")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("h5", { staticClass: "text-center pt-4" }, [
        _vm._v("Logo della tua azienda")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("h5", { staticClass: "black center" }, [_vm._v("Modifica Password")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25d2da78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25d2da78","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/hoval.vue
// module id = null
// module chunks = 